import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import { BlogsMenu } from "./BlogsMenu";
import * as React from "react";
import { useState, useEffect } from "react";
import { getAllBlogs } from "services";
import BlogsHeroComponent from "./BlogsHeroComponent";

interface BlogsData {
  date?: string;
  title?: string;
  description?: string;
  imageLink?: string;
  link?: string;
  category?: string;
}

export const BlogsPage = () => {
  const [progress, setProgress] = React.useState(0);
  const [blogsData, setBlogsData] = useState<BlogsData[]>([]);

  const formatDate = (isoString: any) => {
    return new Date(isoString).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };
  const init = async () => {
    const allLatestPosts: any = await getAllBlogs();
    const filteredData =
      [...(allLatestPosts?.data || [])].map((blog: any, index: number) => ({
        date: formatDate(blog.attributes.publishedAt),
        title: blog.attributes.title.split(" ").slice(0, 10).join(" "),
        description: blog.attributes.description
          .split(" ")
          .slice(0, 10)
          .join(" "),
        imageLink: blog.attributes.image.data.attributes.url,
        link: `/blogs/${blog.attributes.slug}`,
        category: blog.attributes.category.data.attributes.name,
      })) || [];
    setBlogsData(filteredData);
  };

  useEffect(() => {
    (async () => {
      await init();
    })();
  }, []);

  return (
    <>
      <Header />

      <BlogsHeroComponent
        title="TRENDING BLOG"
        subtitle="Tips for Successful Bidding and Acquiring Properties"
        blogsData={blogsData}
        progress={progress}
        setProgress={setProgress}
      />

      <BlogsMenu />
      <Footer />
    </>
  );
};

export default BlogsPage;
